import React, { useState, useEffect, useRef } from "react";
import { Divider, CircularProgress, Grid } from "@material-ui/core";
import { Pagination } from "@material-ui/lab";
import { useQuery, useLazyQuery, useMutation } from "@apollo/react-hooks";
import gql from "graphql-tag";
import moment from "moment";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CancelIcon from "@material-ui/icons/Cancel";

import Table from "../../components/Table";
import { Card, CardContent, CardActions } from "../../components/Card";
import Text from "../../components/Text";
import Button from "../../components/Button";
import { useAlert } from "../../components/Alert";
import ErrorLogReport from "./ErrorLogReport";
import { set } from "date-fns";

const GET_ERRORPROPERTIES = gql`
  query errorProperties($latest: Boolean, $pageSize: Int, $page: Int) {
    errorProperties(latest: $latest, pageSize: $pageSize, page: $page) {
      count
      pageCount
      contents {
        id
        reporter {
          id
          fullName
        }
        errorProperty
        errorLog
        imageUrl
        editor {
          id
          fullName
        }
        editMessage
        createdAt
        updatedAt
      }
    }
  }
`;

export default function ObjErrorReportTable() {
  const [page, setPage] = useState(1);
  const [open, setOpen] = useState(false);
  const [id, setId] = useState(null);
  const Alert = useAlert();

  const { data, refetch, loading } = useQuery(GET_ERRORPROPERTIES, {
    fetchPolicy: "network-only",
    notifyOnNetworkStatusChange: true,
    variables: {
      latest: true,
      pageSize: 10,
      page,
    },
    onError(error) {
      return Alert.notice(`${error}`);
    },
  });
  if (loading) {
    return (
      <Grid container justify="center">
        <CircularProgress color="secondary" />
      </Grid>
    );
  } else {
    return (
      <Card>
        <CardContent>
          <Table
            data={data?.errorProperties.contents}
            tableWidth={2}
            header={[
              "編號",
              "錯誤物件",
              "錯誤訊息",
              "回報者",
              "回報時間",
              "修訂訊息",
              "修訂者",
              "修訂時間",
              "狀態",
              "編修",
            ]}
            columns={[
              (_, index) => <Text>{index + 1}</Text>,
              (item) => <Text>{item.errorProperty}</Text>,
              (item) => <Text>{item.errorLog}</Text>,
              (item) => <Text>{item.reporter.fullName}</Text>,
              (item) => (
                <Text>{moment(item.createdAt).format("yyyy-MM-DD")}</Text>
              ),
              (item) => <Text>{item.editMessage}</Text>,
              (item) => <Text>{item.editor?.fullName}</Text>,
              (item) => (
                <Text>
                  {item.editor?.fullName
                    ? moment(item.updatedAt).format("yyyy-MM-DD")
                    : null}
                </Text>
              ),
              (item) =>
                item.editor?.fullName ? (
                  <CheckCircleIcon style={{ color: "#4caf50" }} />
                ) : (
                  <CancelIcon style={{ color: "#f44336" }} />
                ),
              (item) => (
                <Button
                  variant="contained"
                  color="primary"
                  onPress={() => {
                    setId(item.id);
                    setOpen(true);
                  }}
                >
                  修正
                </Button>
              ),
            ]}
          />
          <ErrorLogReport
            data={{ open, id }}
            onClose={() => {
              setId(null);
              setOpen(false);
            }}
          />
        </CardContent>
        <CardActions>
          <Grid container justifyContent="center">
            <Pagination
              count={
                Boolean(data) && data.errorProperties.pageCount
                  ? data.errorProperties.pageCount
                  : 1
              }
              size="large"
              color="primary"
              page={page}
              onChange={(e, n) => {
                setPage(n);
              }}
            />
          </Grid>
        </CardActions>
      </Card>
    );
  }
}
